// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p4-1";
export var messageSideRight = "_p4-2";
export var subscribeToBackInStockBubbleContainer = "_p4-0";